'use client'

import Link from 'next/link'
import useI18n from '@/hooks/useI18n'
import { withLocale } from '@/locales'

export default function NotFound() {
  const { t, lang } = useI18n()

  return (
    <main
      className="fixed inset-0 z-50 flex flex-col items-center justify-end bg-cover bg-center bg-no-repeat pb-[18vh]"
      style={{ backgroundImage: 'url(/404.webp)' }}
    >
      <Link
        href={withLocale('/', lang)}
        className="group relative overflow-hidden rounded-full bg-gradient-to-r from-[#9C4844] to-[#E7716B] px-10 py-3.5 text-base font-semibold text-white shadow-[0_0_24px_rgba(231,113,107,0.45)] transition-all duration-300 hover:scale-105 hover:shadow-[0_0_36px_rgba(231,113,107,0.65)] active:scale-95"
      >
        <span className="relative z-10">{t('404:backToHome')}</span>
        <span className="absolute inset-0 z-0 bg-gradient-to-r from-[#E7716B] to-[#9C4844] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      </Link>
    </main>
  )
}
